module.exports = __webpack_public_path__ + "img/16.1e033018.jpg";